import { render, staticRenderFns } from "./trash-products.vue?vue&type=template&id=e61b970c&scoped=true&"
import script from "./trash-products.vue?vue&type=script&lang=js&"
export * from "./trash-products.vue?vue&type=script&lang=js&"
import style0 from "./trash-products.vue?vue&type=style&index=0&id=e61b970c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b970c",
  null
  
)

export default component.exports